import { Box, Typography } from "@mui/material";

const SectionLabel = ({
  title,
  subTitle,
  fontSize,
  fontSubTitleSize,
  ...rest
}) => (
  <Box {...rest}>
    {title && (
      <Typography fontSize={fontSize || "18px"} fontWeight={700}>
        {title}
      </Typography>
    )}
    {subTitle && (
      <Typography fontSize={fontSubTitleSize || "14px"} color="#8F8F8F">
        {subTitle}
      </Typography>
    )}
  </Box>
);

export default SectionLabel;
